import { jsx as i, jsxs as n, Fragment as g } from "react/jsx-runtime";
import { IconNames as O } from "@blueprintjs/icons";
import { capitalizeString as J, getTimeDiffStr as ie, formatDate as T, DateFormats as Q, sortDateAsc as oe, sortDateDesc as re } from "@strata/helper-functions";
import { ActionButtonText as B } from "@strata/react-buttons";
import { FormSection as X } from "@strata/react-form-section";
import { MessagingBlock as C } from "@strata/react-messaging-block";
import { WorklistStatusIndicator as p } from "@strata/react-status-indicators";
import ae from "classnames";
import b from "dayjs";
import { useState as w, useMemo as R, useEffect as z } from "react";
import { Dialog as se, DialogWithForm as ne } from "@strata/react-dialog";
import { CollapsibleSection as le } from "@strata/react-collapsible-section";
import { DollarAmount as de } from "@strata/react-dollar-amount";
import { DetailLabel as ce, DetailLabelValuePair as c } from "@strata/react-label-value-pairs";
import { ServicingRate as ue } from "@strata/react-servicing-rate";
import { Checkbox as me } from "@strata/react-checkbox-list";
import { ReasonInput as Z } from "@strata/react-compound-inputs";
import { InlineMessage as H } from "@strata/react-inline-message";
import { Formik as pe } from "formik";
import * as G from "yup";
import { Card as L } from "@strata/react-cards";
import { ActionButtonTextDropdownMenu as he } from "@strata/react-dropdown-menu";
import { StatusIcon as x, InformationIcon as _e } from "@strata/react-status-icons";
import { Tag as fe } from "@strata/react-tags";
import { TimeIndicator as ge, CountdownTimer as ve } from "@strata/react-timers";
import "./main.scss";
import { filterDataFromSearch as be, filterData as Se, FilterPane as Te } from "@strata/react-filter-pane";
const D = {
  REFERRAL: "REFERRAL",
  PENDREFER: "PENDREFER",
  CLAIMS: "CLAIMS",
  PERF: "PERF"
}, k = {
  // REFERRAL
  NBD: "NBD",
  // PENDREFER
  PENDINTAKE: "PENDINTAKE",
  ACCEPTANCE: "ACCEPTANCE",
  // CLAIMS
  REBILL: "REBILL",
  // PERF
  MANSUBTASK: "MANSUBTASK"
}, M = {
  ACCEPTED: "ACCEPTED",
  MOVED: "MOVED"
}, y = (e) => (e == null ? void 0 : e.task_status) === p.Statuses.TODO, F = ({
  dueDate: e,
  completedDate: o
}) => b(o ?? void 0) >= b(e), W = ({
  isOpen: e,
  onPrimaryButtonClick: o,
  onSecondaryButtonClick: r,
  usePortal: a
}) => /* @__PURE__ */ i(
  se,
  {
    dialogTitle: "Confirm Clear Task(s)",
    isOpen: e,
    primaryButtonLabel: "Clear Task(s)",
    onPrimaryButtonClick: o,
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: r,
    dialogContent: "Task(s) will be cleared from view. They can no longer be accessible through the Worklist page.",
    usePortal: a
  }
), ee = "Patient discontinued therapy", ye = [
  "Can't reach the patient",
  "Can't reach the prescriber",
  "The patient is on a therapy holiday",
  ee,
  "Unable to obtain the prescription"
], Ee = G.object({
  ...Z.validationSchema,
  beginSupportConversation: G.bool().required()
}), Ce = ({
  taskDescription: e = void 0,
  isOpen: o,
  onSecondaryButtonClick: r,
  onSubmit: a,
  usePortal: t
}) => /* @__PURE__ */ i(
  pe,
  {
    initialValues: { beginSupportConversation: !1 },
    validationSchema: Ee,
    onSubmit: (l, { resetForm: s }) => {
      a({
        reason: l.reason,
        beginSupportConversation: l.beginSupportConversation
      }), s();
    },
    children: (l) => /* @__PURE__ */ i(
      ne,
      {
        dialogTitle: "Confirm Unable To Complete",
        headerIcon: O.WARNING_SIGN,
        isOpen: o,
        width: 600,
        usePortal: t,
        primaryButtonLabel: "Yes, Move To Expired",
        secondaryButtonLabel: "No, Return To Worklist",
        onSecondaryButtonClick: (s) => {
          r(s), l.handleReset();
        },
        dialogContent: /* @__PURE__ */ n(g, { children: [
          /* @__PURE__ */ i("div", { className: "margin__bottom--medium", children: "This action will move this task to expired. Are you sure you want to continue?" }),
          /* @__PURE__ */ i("div", { className: "margin__bottom--medium font-semi-bold", children: e }),
          /* @__PURE__ */ i(Z, { reasons: ye, hideSource: !0 }),
          l.values.reason === ee && /* @__PURE__ */ n(g, { children: [
            /* @__PURE__ */ i("div", { className: "margin__bottom--small", children: /* @__PURE__ */ i(
              H,
              {
                intent: H.Intent.INFO,
                wrapText: !0,
                label: "Please begin a support conversation with FMH support to discontinue this referral."
              }
            ) }),
            /* @__PURE__ */ i(
              me,
              {
                name: "beginSupportConversation",
                label: "Begin a support conversation",
                checked: l.values.beginSupportConversation,
                onChange: (s) => {
                  l.setFieldValue(
                    "beginSupportConversation",
                    s
                  );
                }
              }
            )
          ] })
        ] })
      }
    )
  }
), Ne = ({
  dueDate: e,
  warningDate: o = void 0,
  completedDate: r = void 0
}) => /* @__PURE__ */ n("div", { children: [
  /* @__PURE__ */ i(ce, { label: F({ dueDate: e, completedDate: r }) ? "Overdue By" : "Due In" }),
  r ? /* @__PURE__ */ i(
    ge,
    {
      showTimePastEnded: !0,
      timeInSeconds: b(r).diff(e, "seconds")
    }
  ) : /* @__PURE__ */ i(
    ve,
    {
      showTimePastEnded: !0,
      endTime: e,
      cautionTimeThresholdSeconds: 0,
      warningTimeThresholdSeconds: b(e).diff(o, "seconds")
    }
  )
] }), we = (e) => {
  switch (e) {
    case p.Statuses.COMPLETED:
    case p.Statuses.WAITING:
      return x.Statuses.GOOD;
    default:
      return;
  }
}, De = ({
  dueDate: e,
  warningDate: o,
  taskStatus: r
}) => {
  if (r !== p.Statuses.COMPLETED && r !== p.Statuses.WAITING) {
    if (b().diff(e, "second") >= 0)
      return L.Statuses.CAUTION;
    if (o && b().diff(o, "second") >= 0)
      return L.Statuses.WARNING;
  }
}, Ae = ({
  dueDate: e,
  completedDate: o,
  actionTaken: r,
  actionTakenBy: a,
  actionTakenReason: t
}) => /* @__PURE__ */ n("div", { className: "flex__gap--small", style: { alignItems: "center" }, children: [
  /* @__PURE__ */ i("span", { className: "font-bold", children: r === M.MOVED ? "Task was unable to be completed." : `Completed ${ie(e, o)} ${F({ dueDate: e, completedDate: o }) ? "after the due date." : "before the due date!"}` }),
  t && /* @__PURE__ */ i(
    _e,
    {
      size: 16,
      className: "padding__right--x-small",
      tooltipText: /* @__PURE__ */ n(g, { children: [
        /* @__PURE__ */ i("span", { className: "font-bold", children: "Reason: " }),
        /* @__PURE__ */ i("span", { children: t })
      ] })
    }
  ),
  /* @__PURE__ */ i("span", { children: `${J(r ?? "Completed")} on ${T(
    o
  )} at ${T(o, Q.TIME)} by ${a ?? "System"}.` })
] }), Pe = ({
  taskType: e = void 0,
  taskCategory: o = void 0,
  taskStatus: r = void 0,
  description: a = void 0,
  dueDate: t = void 0,
  warningDate: l = void 0,
  completedDate: s = void 0,
  displayId: h = void 0,
  additionalInfo: u = void 0,
  actions: m = [],
  actionTaken: d = void 0,
  actionTakenBy: v = void 0,
  actionTakenReason: _ = void 0
}) => /* @__PURE__ */ i(
  L,
  {
    className: "sds_worklist-task-card",
    showStatusIcon: !0,
    iconStatus: we(r),
    cardStatus: De({ dueDate: t, warningDate: l, taskStatus: r }),
    headerLeftContent: e && /* @__PURE__ */ n("div", { children: [
      /* @__PURE__ */ i("span", { className: "font-bold--uppercase", children: `${e} | ` }),
      /* @__PURE__ */ i("span", { className: "font-regular--uppercase", children: o })
    ] }),
    headerRightContent: r !== p.Statuses.COMPLETED && /* @__PURE__ */ i(p, { status: r }),
    bodyContent: /* @__PURE__ */ n(g, { children: [
      /* @__PURE__ */ n("div", { className: "sds_worklist-task-card__body-row padding__bottom--medium", children: [
        /* @__PURE__ */ i("span", { children: a }),
        h && /* @__PURE__ */ i("span", { className: "sds_worklist-task-card__task-id font-regular--uppercase", children: `Task ID: ${h}` })
      ] }),
      /* @__PURE__ */ n("div", { className: "sds_worklist-task-card__body-row", children: [
        /* @__PURE__ */ n("div", { className: "sds_worklist-task-card__body-row__content", children: [
          t && /* @__PURE__ */ i(
            Ne,
            {
              dueDate: t,
              warningDate: l,
              completedDate: s
            }
          ),
          u
        ] }),
        m.length > 0 && (m.length > 1 ? /* @__PURE__ */ i(he, { label: "Actions", menuItems: m }) : /* @__PURE__ */ i(
          B,
          {
            label: m[0].text,
            onClick: m[0].onItemClick
          }
        ))
      ] })
    ] }),
    rows: s ? [
      {
        leftContent: /* @__PURE__ */ n("div", { className: "sds_worklist-task-card__row", children: [
          /* @__PURE__ */ i(
            x,
            {
              size: 16,
              status: F({ dueDate: t, completedDate: s }) || d === M.MOVED ? x.Statuses.CAUTION : x.Statuses.GOOD,
              className: "padding__left--small padding__right--large"
            }
          ),
          Ae({
            dueDate: t,
            completedDate: s,
            actionTaken: d,
            actionTakenBy: v,
            actionTakenReason: _
          })
        ] }),
        rightContent: d && d !== M.MOVED && /* @__PURE__ */ i(fe, { label: J(d) })
      }
    ] : void 0
  }
), xe = ({
  task: e,
  onTaskActionClick: o,
  onUnableToComplete: r = void 0,
  onClearTasksClick: a = void 0
}) => {
  const t = e.task_info, [l, s] = w(!1), [h, u] = w(!1), m = a && !y(e) && e.task_status !== p.Statuses.WAITING, d = (_) => [
    ..._.map(({ text: f, onItemClick: E }) => ({
      text: f,
      onItemClick: E ?? (() => o(e))
    })),
    ...m ? [{ text: "Clear Task", onItemClick: () => u(!0) }] : []
  ], v = {
    taskType: e.task_type_display_name,
    taskCategory: e.task_category_display_name,
    taskStatus: e.task_status,
    dueDate: e.due_date,
    warningDate: e.warning_date,
    completedDate: e.completed_date,
    displayId: e.display_id,
    actionTaken: e.action_taken,
    actionTakenBy: e.action_taken_by,
    actionTakenReason: e.action_taken_reason,
    ...{
      [D.REFERRAL]: {
        // Only Needs By Date task type for category right now
        description: "Confirm or update the needs by date for this patient.",
        actions: d([
          { text: y(e) ? "Confirm/Update" : "View Referral" }
        ]),
        additionalInfo: /* @__PURE__ */ n(g, { children: [
          /* @__PURE__ */ i(c, { label: "Product", value: t == null ? void 0 : t.product_name }),
          /* @__PURE__ */ i(c, { label: "Health Plan", value: e.health_plan }),
          /* @__PURE__ */ i(c, { label: "Patient", value: t == null ? void 0 : t.patient_name }),
          /* @__PURE__ */ i(
            c,
            {
              label: "Next Fill Needs By Date",
              value: T(t == null ? void 0 : t.needs_by_date)
            }
          )
        ] })
      },
      [D.PENDREFER]: {
        description: `${e.task_type === k.PENDINTAKE ? "Accept/decline this pending referral" : "Accept this referral"} before ${T(e.due_date, Q.DATE_LONG)}`,
        actions: d(
          y(e) ? [{ text: "Review" }] : e.task_status === p.Statuses.COMPLETED && e.action_taken === M.ACCEPTED ? [{ text: "View Referral" }] : []
        ),
        additionalInfo: /* @__PURE__ */ n(g, { children: [
          /* @__PURE__ */ i(c, { label: "Product", value: t == null ? void 0 : t.product_name }),
          /* @__PURE__ */ i(c, { label: "Health Plan", value: e.health_plan }),
          /* @__PURE__ */ i(
            c,
            {
              label: "Rate",
              value: /* @__PURE__ */ i(
                ue,
                {
                  servicingRate: t == null ? void 0 : t.offer_rate,
                  referentPriceType: t == null ? void 0 : t.referent_price_type
                }
              )
            }
          )
        ] })
      },
      [D.CLAIMS]: {
        description: "A rebilling is required because of a discrepancy in submitted price.",
        actions: d([
          { text: y(e) ? "Confirmation" : "View Referral" }
        ]),
        additionalInfo: /* @__PURE__ */ n(g, { children: [
          /* @__PURE__ */ i(c, { label: "Product", value: t == null ? void 0 : t.product_name }),
          /* @__PURE__ */ i(
            c,
            {
              label: "Date Of Service",
              value: T(t == null ? void 0 : t.date_of_service)
            }
          ),
          /* @__PURE__ */ i(
            c,
            {
              label: "Adjudication Date",
              value: T(t == null ? void 0 : t.adjudication_date)
            }
          ),
          /* @__PURE__ */ i(c, { label: "Patient", value: t == null ? void 0 : t.patient_name }),
          /* @__PURE__ */ i(
            c,
            {
              label: "Billing NPI",
              value: t == null ? void 0 : t.billing_supplier_npi
            }
          )
        ] })
      },
      [D.PERF]: {
        description: `${t == null ? void 0 : t.value_case_name} is missing documentation.`,
        actions: d(
          y(e) ? [
            { text: "Add Documentation" },
            ...r ? [
              {
                text: "Unable to Complete",
                onItemClick: () => s(!0)
              }
            ] : []
          ] : [{ text: "View Referral" }]
        ),
        additionalInfo: /* @__PURE__ */ n(g, { children: [
          /* @__PURE__ */ i(c, { label: "Product", value: t == null ? void 0 : t.product_name }),
          /* @__PURE__ */ i(c, { label: "Patient", value: t == null ? void 0 : t.patient_name }),
          /* @__PURE__ */ i(
            c,
            {
              label: "DOB",
              value: T(t == null ? void 0 : t.member_date_of_birth)
            }
          ),
          t && (t.incentive ?? 0) > 0 && /* @__PURE__ */ i(
            c,
            {
              label: "Incentive",
              value: /* @__PURE__ */ i(de, { amount: t.incentive, hideCents: !0, large: !0 })
            }
          )
        ] })
      }
    }[e.task_category]
  };
  return /* @__PURE__ */ n(g, { children: [
    /* @__PURE__ */ i(Pe, { ...v }),
    r && /* @__PURE__ */ i(
      Ce,
      {
        taskDescription: t == null ? void 0 : t.value_case_name,
        isOpen: l,
        onSubmit: ({ reason: _, beginSupportConversation: f }) => {
          r({ task: e, reason: _, beginSupportConversation: f }), s(!1);
        },
        onSecondaryButtonClick: () => s(!1)
      }
    ),
    m && /* @__PURE__ */ i(
      W,
      {
        isOpen: h,
        onPrimaryButtonClick: () => {
          a([e.task_id]), u(!1);
        },
        onSecondaryButtonClick: () => u(!1)
      }
    )
  ] });
}, N = ({
  title: e,
  headerAction: o = void 0,
  renderExpanded: r = !0,
  tasks: a = void 0,
  onTaskActionClick: t,
  onUnableToComplete: l,
  onClearTasksClick: s,
  customNoTasksMessage: h = void 0
}) => {
  const u = `${e} (${(a == null ? void 0 : a.length) ?? 0})`, m = R(
    () => /* @__PURE__ */ i("div", { className: "sds_worklist-section__tasks", children: a && a.length > 0 ? a.map((d) => /* @__PURE__ */ i(
      xe,
      {
        task: d,
        onTaskActionClick: t,
        onUnableToComplete: l,
        onClearTasksClick: s
      },
      d.task_id
    )) : /* @__PURE__ */ i("div", { className: "sds_worklist-section__no-tasks", children: h ?? /* @__PURE__ */ i("span", { className: "sds_worklist-section__no-tasks--default-text", children: "No tasks to show." }) }) }),
    [a, h, t, l, s]
  );
  return /* @__PURE__ */ i(
    le,
    {
      className: "sds_worklist-section",
      title: u,
      content: m,
      renderExpanded: r,
      rightHeaderContent: /* @__PURE__ */ i("div", { className: "sds_worklist-section__header-action", children: o })
    }
  );
}, te = "Tasks", Oe = (e) => {
  const o = { overdue: [], today: [], upcoming: [], expired: [], completed: [] };
  e == null || e.forEach((a) => {
    y(a) ? b().diff(a.due_date, "second") >= 0 ? o.overdue.push(a) : b().diff(a.due_date, "day") === 0 ? o.today.push(a) : o.upcoming.push(a) : a.task_status === p.Statuses.FAILED ? o.expired.push(a) : o.completed.push(a);
  });
  const r = (a, t) => oe(a.due_date, t.due_date);
  return o.overdue.sort(r), o.today.sort(r), o.upcoming.sort(r), o.expired.sort(r), o.completed.sort((a, t) => re(a.completed_date, t.completed_date)), o;
}, K = (e, o) => !e || o.length > 0, Y = (e, o) => (e ?? []).filter((r) => r.task_status === o).map((r) => r.task_id), V = ({
  tasks: e = void 0,
  areFiltersActive: o = !1,
  onTaskActionClick: r,
  onUnableToComplete: a,
  onClearTasksClick: t,
  className: l = void 0
}) => {
  const s = R(() => Oe(e), [e]), [h, u] = w(!1), [m, d] = w(!1), v = s.overdue.length === 0 && s.today.length === 0 && s.upcoming.length === 0, _ = {
    expired: s.expired.length > 0 && /* @__PURE__ */ n(g, { children: [
      /* @__PURE__ */ i(
        B,
        {
          label: "Clear All Expired Tasks",
          disabled: !t,
          onClick: () => u(!0)
        }
      ),
      /* @__PURE__ */ i(
        W,
        {
          isOpen: h,
          onPrimaryButtonClick: () => {
            t == null || t(
              Y(e, p.Statuses.FAILED)
            ), u(!1);
          },
          onSecondaryButtonClick: () => u(!1)
        }
      )
    ] }),
    completed: s.completed.length > 0 && /* @__PURE__ */ n(g, { children: [
      /* @__PURE__ */ i(
        B,
        {
          label: "Clear All Completed Tasks",
          disabled: !t,
          onClick: () => d(!0)
        }
      ),
      /* @__PURE__ */ i(
        W,
        {
          isOpen: m,
          onPrimaryButtonClick: () => {
            t == null || t(
              Y(e, p.Statuses.COMPLETED)
            ), d(!1);
          },
          onSecondaryButtonClick: () => d(!1)
        }
      )
    ] })
  };
  return /* @__PURE__ */ i(
    X,
    {
      className: ae("sds_worklist", l),
      sectionTitle: te,
      isLoading: !e,
      content: o ? (
        // Only show sections w/ tasks when filters are applied
        Object.entries(s).filter(([f, E]) => E.length > 0).map(([f, E]) => /* @__PURE__ */ i(
          N,
          {
            title: f,
            tasks: E,
            onTaskActionClick: r,
            onUnableToComplete: a,
            onClearTasksClick: t,
            headerAction: _[f]
          },
          f
        ))
      ) : /* @__PURE__ */ n(g, { children: [
        v ? /* @__PURE__ */ i("div", { className: "sds_worklist-section", children: /* @__PURE__ */ i(
          C,
          {
            className: "sds_worklist-section__no-tasks",
            size: C.Sizes.MEDIUM,
            icon: O.THUMBS_UP,
            iconStatus: C.Status.SUCCESS,
            primaryText: "All caught up!",
            secondaryText: "Procrastination isn't part of your business."
          }
        ) }) : /* @__PURE__ */ n(g, { children: [
          s.overdue.length > 0 && /* @__PURE__ */ i(
            N,
            {
              title: "Overdue",
              tasks: s.overdue,
              onTaskActionClick: r,
              onUnableToComplete: a,
              onClearTasksClick: t
            }
          ),
          /* @__PURE__ */ i(
            N,
            {
              title: "Today",
              tasks: s.today,
              onTaskActionClick: r,
              onUnableToComplete: a,
              onClearTasksClick: t
            }
          ),
          /* @__PURE__ */ i(
            N,
            {
              title: "Upcoming",
              tasks: s.upcoming,
              onTaskActionClick: r,
              onUnableToComplete: a,
              onClearTasksClick: t
            }
          )
        ] }),
        K(v, s.expired) && /* @__PURE__ */ i(
          N,
          {
            title: "Expired",
            tasks: s.expired,
            onTaskActionClick: r,
            onUnableToComplete: a,
            onClearTasksClick: t,
            renderExpanded: !1,
            headerAction: _.expired
          }
        ),
        K(v, s.completed) && /* @__PURE__ */ i(
          N,
          {
            title: "Completed",
            tasks: s.completed,
            onTaskActionClick: r,
            onUnableToComplete: a,
            onClearTasksClick: t,
            renderExpanded: !1,
            headerAction: _.completed,
            customNoTasksMessage: /* @__PURE__ */ i(
              C,
              {
                size: C.Sizes.MEDIUM,
                icon: O.FORM,
                primaryText: "Complete some tasks to get caught up.",
                secondaryText: "No completed tasks to show."
              }
            )
          }
        )
      ] })
    }
  );
};
V.WorkTaskCategory = D;
V.WorkTaskType = k;
const q = [
  {
    key: "due_date",
    title: "Timeframe",
    showCounts: !0,
    customValues: [
      {
        value: "Overdue",
        handler: (e, o) => y(o) && b().diff(e, "second") >= 0
      },
      {
        value: "Today",
        handler: (e, o) => y(o) && b().diff(e, "day") === 0
      },
      {
        value: "Upcoming",
        handler: (e, o) => y(o) && b().diff(e, "day") < 0
      }
    ]
  },
  {
    key: "task_category_display_name",
    title: "Task Category",
    showCounts: !0
  },
  {
    key: "task_type_display_name",
    title: "Task",
    showCounts: !0
  },
  {
    key: "task_status",
    title: "Status",
    valueDisplayTextMap: p.StatusMessages,
    showCounts: !0
  },
  {
    key: "product_name",
    title: "Product",
    showCounts: !0
  },
  {
    key: "health_plan",
    title: "Health Plan",
    showCounts: !0
  }
], Re = {
  task_status: (e) => p.StatusMessages[e],
  due_date: (e) => T(e),
  completed_date: (e) => T(e),
  task_info: (e) => Object.values(e ?? {}).join()
}, at = ({
  tasks: e,
  onTaskActionClick: o,
  onUnableToComplete: r,
  onClearTasksClick: a,
  title: t,
  secondaryTitle: l,
  headerContent: s,
  activeFilters: h,
  onFilter: u,
  filterPaneRenderWidth: m = void 0,
  onFilterPaneResize: d = void 0,
  searchText: v,
  onSearch: _
}) => {
  const [f, E] = w(h);
  z(() => {
    E(h);
  }, [h]);
  const [A, $] = w(v);
  z(() => {
    $(v);
  }, [v]);
  const I = R(
    () => e == null ? void 0 : e.map((S) => {
      var j;
      return { ...S, product_name: (j = S.task_info) == null ? void 0 : j.product_name };
    }),
    [e]
  ), P = R(
    () => be(
      Se(I, f, q),
      A,
      Re
    ),
    [I, f, A]
  ), U = !!A || Object.values(f ?? {}).some((S) => (S ?? []).length > 0);
  return /* @__PURE__ */ i(
    Te,
    {
      paneRenderWidth: m,
      onPaneResize: d,
      title: t,
      secondaryTitle: l,
      headerContent: s,
      filterCategories: q,
      activeFilters: f,
      onFilter: (S) => {
        u == null || u(S), E(S);
      },
      enableSearch: !0,
      searchText: A,
      onSearch: (S) => {
        _ == null || _(S), $(S);
      },
      data: I,
      mainContent: U && (P == null ? void 0 : P.length) === 0 ? /* @__PURE__ */ i(
        X,
        {
          className: "sds_worklist--filters",
          sectionTitle: te,
          content: /* @__PURE__ */ i(
            C,
            {
              className: "sds_worklist-section__no-tasks",
              size: C.Sizes.MEDIUM,
              icon: O.SEARCH,
              primaryText: "No results to show.",
              secondaryText: "Try a different search."
            }
          )
        }
      ) : /* @__PURE__ */ i(
        V,
        {
          className: "sds_worklist--filters",
          tasks: P,
          areFiltersActive: U,
          onTaskActionClick: o,
          onUnableToComplete: r,
          onClearTasksClick: a
        }
      )
    }
  );
};
export {
  V as Worklist,
  Ne as WorklistTimer,
  at as WorklistWithFilters,
  y as isTaskTodo
};
//# sourceMappingURL=index.js.map
